export default __webpack_public_path__ + "1ebb8ee174a5aebfb7d49ad4933c7fcf.png";